import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OSearchService } from './osearch.service';
import { OverrideService } from './../../shared/services/override.service';
import { EntityService } from './../../shared/services/entity.service';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ColDef, GridApi, CellClickedEvent } from 'ag-grid-community';

@Component({
  selector: "searchResults",
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  searchResult: { route: string; entity: Object }[];
  gridApi: GridApi;
  gridColumnApi: any;
  constructor(
    private entity: EntityService,
    public override: OverrideService,
    private search: OSearchService,
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.searchResult = this.search.searchResult;
  }
  columnDefs: ColDef[] = [
    {
      headerName: this.translate.instant('Type'),
      field: 'route',
      filter: true,
      sortable: true,
      editable: false,
      cellRenderer: (params) => {
        return this.translate.instant(params.value);
      },
      onCellClicked: (event: CellClickedEvent) => {
        let data = event.data;
        this.router.navigate(['pages', data.route, 'edit', data.entity.id]);
      },
    },
    {
      headerName: this.translate.instant('Id'),
      field: 'entity.id',
      filter: true,
      sortable: true,
      editable: false,
      onCellClicked: (event: CellClickedEvent) => {
        let data = event.data;
        this.router.navigate(['pages', data.route, 'edit', data.entity.id]);
      },
      // cellRenderer: (params) => {
      //   return this.translate.instant(params.value);
      // },
    },
    {
      headerName: this.translate.instant('Name'),
      field: 'entity.name.' + this.override.currentLang || 'entity.name',
      filter: true,
      sortable: true,
      editable: false,
      onCellClicked: (event: CellClickedEvent) => {
        let data = event.data;
        this.router.navigate(['pages', data.route, 'edit', data.entity.id]);
      },
      // cellRenderer: (params) => {
      //   return this.translate.instant(params.value);
      // },
    },
    {
      headerName: this.translate.instant('Email'),
      field: 'entity.email',
      filter: true,
      sortable: true,
      editable: false,
      onCellClicked: (event: CellClickedEvent) => {
        let data = event.data;
        this.router.navigate(['pages', data.route, 'edit', data.entity.id]);
      },
      // cellRenderer: (params) => {
      //   return this.translate.instant(params.value);
      // },
    },
 
  ];

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  get class() {
    let theme = localStorage.getItem('currentTheme');
    switch (theme) {
      case 'dark':
        return 'ag-theme-alpine';
      case 'cosmic':
        return 'ag-theme-alpine';
      default:
        return 'ag-theme-alpine';
    }
  }
}
